import { Extension } from '@tiptap/core';

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    customTable: {
      clearMarks: () => ReturnType;
    };
  }
}

/**
 * This extension manually clears all marks
 * before inserting a new paragraph.
 */
const CustomEnter = Extension.create({
  name: 'customEnter',
  addCommands() {
    return {
      clearMarks:
        () =>
        ({ tr }) => {
          tr.setStoredMarks([]);
          return true;
        },
    };
  },
  addKeyboardShortcuts() {
    return {
      Enter: ({ editor }) => {
        editor.commands.clearMarks();
        /**
         * Here we're returning false because we want to fall back
         * to the default enter behaviour, but not before clearing marks.
         */
        return false;
      },
    };
  },
});

export default CustomEnter;
